var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 3.33268H7.08333V2.49935C7.08333 1.34935 6.15 0.416016 5 0.416016C3.85 0.416016 2.91666 1.34935 2.91666 2.49935V3.33268H2.5C2.04166 3.33268 1.66666 3.70768 1.66666 4.16602V8.33268C1.66666 8.79102 2.04166 9.16602 2.5 9.16602H7.5C7.95833 9.16602 8.33333 8.79102 8.33333 8.33268V4.16602C8.33333 3.70768 7.95833 3.33268 7.5 3.33268ZM5 7.08268C4.54166 7.08268 4.16666 6.70768 4.16666 6.24935C4.16666 5.79102 4.54166 5.41602 5 5.41602C5.45833 5.41602 5.83333 5.79102 5.83333 6.24935C5.83333 6.70768 5.45833 7.08268 5 7.08268ZM3.75 2.49935V3.33268H6.25V2.49935C6.25 1.80768 5.69166 1.24935 5 1.24935C4.30833 1.24935 3.75 1.80768 3.75 2.49935Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.bc0a8111ea933f6173c3765c4223db05.svg";
export { ForwardRef as ReactComponent };